// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TrackedLinkController from "./tracked_link_controller"
application.register("tracked-link", TrackedLinkController)
